module.exports = __webpack_public_path__ + "img/home-quotation-green.909a849b.png";